import { CommonData } from './../shared/common';
import {useQuery} from 'react-query';
import api from '../api/api';

export const fetchPartners = async (): Promise<CommonData[]> => {
	const {data} = await api.get<{data: CommonData[]}>("/web/v1/partners");
	return data.data;
}

export const  usePartners = () => {
    return useQuery("partners",  fetchPartners);
}